import { AxiosResponse } from "axios";
import { MERCHANT_V3_API_URLS as M3_API } from "@/apps/merchant3/services/apiClient/apiUrl";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

interface IContractQueryParams {
  locale?: string;
  signed?: string | number;
}

export const getContract = async (
  cartTag: string,
  queryParam?: IContractQueryParams
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.get(M3_API(cartTag).GET_CONTRACT, {
    params: { signed: queryParam?.signed, locale: queryParam?.locale },
    headers: {
      Prefer:
        queryParam?.signed == 1
          ? "example=Get Signed Contract"
          : "code=200, example=Get Contract",
    },
  });
};

export const signContract = async (
  cartTag: string,
  signatureVerification?: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(
    M3_API().SIGN_CONTRACT,
    { cartTag, signatureVerification },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

export const getWelcomeCallStatus = async (
  cartTag: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.get(M3_API(cartTag).WELCOME_CALL_STATUS);
};

export const requestContractPin = async (
  cartTag: string,
  phone: string
): Promise<AxiosResponse<unknown>> => {
  return await jwtApiClient.put(M3_API().REQUEST_CONTRACT_PIN, {
    cartTag,
    phone,
  });
};
